import { Controller } from "@hotwired/stimulus";

// LRPO-5922 (r2) — Notifications, Enter Manually and Switch Exhibitor are
// popups that only exist INSIDE the Dashboard page (turbo frames / a stream).
// A popup route visited directly (new tab) redirects to the Dashboard with
// ?open=<popup>; this controller replays the in-page trigger so the popup
// opens over the real page, and strips the param so reload/Back stay quiet.
const TRIGGERS = {
  notifications: '[data-turbo-frame="notification_center_frame"]',
  manual_lead: '[data-turbo-frame="exhibitor_create_manual_lead_frame"]',
  switch_exhibitor: 'a[href$="/exhibitor/switch_event"]'
};

export default class extends Controller {
  connect() {
    const url = new URL(window.location.href);
    const selector = TRIGGERS[url.searchParams.get("open")];
    if (!selector) return;

    url.searchParams.delete("open");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);

    // Missing trigger (e.g. a door-scanning exhibitor has no Enter Manually)
    // is not an error — the user is simply on the Dashboard.
    document.querySelector(selector)?.click();
  }
}
